import { useHistory } from 'react-router-dom'
import OrganizationalMenu from '../../../../../components/stories/organisms/top-navigation/components/organizational-menu'
import {
  getIsAdmin,
  getPermissions
} from '../../../../../react-query/authentication/query/use-me-query'
import { useFlag } from '@unleash/proxy-client-react'
import { unleashFlags } from '../../../../../unleash-constants'

const Settings = () => {
  const permissions = getPermissions()
  const isAdmin = getIsAdmin()
  const reportsEnabled = useFlag(unleashFlags.REPORTS)
  const { push } = useHistory()

  if (!permissions) {
    return null
  }

  const canSeeUserManagement = permissions.includes('ViewUsers') && isAdmin
  const canSeeReportTemplates =
    permissions.includes('ViewReportTemplates') && reportsEnabled

  const handleNavigateToManageUsers = () => {
    push('/userManagement')
  }

  const handleNavigateToReportTemplates = () => {
    push('/reports?view=templates')
  }

  if (!canSeeUserManagement && !canSeeReportTemplates) {
    return null
  }

  return (
    <OrganizationalMenu
      key="settings"
      onClickManageUsers={handleNavigateToManageUsers}
      onClickReportTemplates={handleNavigateToReportTemplates}
      canSeeUserManagement={canSeeUserManagement}
      canSeeReportTemplates={canSeeReportTemplates}
    />
  )
}

export default Settings
